import { motion } from 'framer-motion';
import { ArrowUpRight } from 'lucide-react';
import { useLang } from '../i18n';
import { EASE } from './motion';
import { catLabel, priceFmt } from './ProductModal';

const ProductCard = ({ product, index, onOpen }) => {
  const { t } = useLang();
  return (
    <motion.article
      layout
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, scale: 0.96 }}
      transition={{ duration: 0.6, ease: EASE, delay: Math.min(index * 0.04, 0.4) }}
      className="group border border-foreground/10 bg-card flex flex-col cursor-pointer"
      onClick={() => onOpen(product)}
      data-testid={`product-card-${product.slug}`}
    >
      <div className="overflow-hidden aspect-square relative bg-muted">
        <img
          src={product.image}
          alt={product.name}
          loading="lazy"
          className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
        />
        <span className="absolute top-3 left-3 bg-[#22303C] text-[#F7F5F0] text-[10px] font-display font-bold uppercase tracking-[0.2em] px-3 py-1.5">
          {catLabel(product.category, t)}
        </span>
      </div>
      <div className="p-5 flex items-end justify-between gap-3 flex-1">
        <div>
          <h3 className="font-display font-bold text-lg leading-tight tracking-tight">{product.name}</h3>
          <p className="text-sm text-foreground/50 mt-1" data-testid={`product-price-${product.slug}`}>{priceFmt(product.price)}</p>
        </div>
        <span className="w-10 h-10 shrink-0 border border-foreground/15 flex items-center justify-center transition-colors duration-300 group-hover:bg-secondary group-hover:border-secondary group-hover:text-white">
          <ArrowUpRight className="w-4 h-4" />
        </span>
      </div>
    </motion.article>
  );
};

export default ProductCard;
